module.exports = __webpack_public_path__ + "media/images/icons/icon-rocket-7a6fa0f2030d0b41e3e04f1ce2d783c1.png";